import api from "@/lib/api";
import { getStoredCurrentEnvironment } from "@/lib/environment";

const TIANJI_ADMIN_PREFIX = "/admin/tianji";

export interface TianjiEnvelope<T = unknown> {
  success: boolean;
  data: T;
  meta: { request_id: string; environment: string; generated_at: string };
}

function environmentHeader(): string {
  const current = getStoredCurrentEnvironment();
  return current?.is_prod ? "production" : "sandbox";
}

export function reviewEnvironmentHeader(): "cn-pre" | "app-review" | null {
  const current = getStoredCurrentEnvironment();
  if (current?.is_prod) return null;
  return current?.env_code.toLowerCase().includes("app-review")
    ? "app-review"
    : "cn-pre";
}

function headers(environment?: string, requestId?: string) {
  return {
    "X-Tianji-Environment": environment ?? environmentHeader(),
    "X-Admin-Request-ID": requestId ?? crypto.randomUUID(),
  };
}

export async function getTianji<T>(path: string, params?: Record<string, unknown>, environment?: string): Promise<TianjiEnvelope<T>> {
  const response = await api.get<TianjiEnvelope<T>>(`${TIANJI_ADMIN_PREFIX}/${path}`, { params, headers: headers(environment) });
  return response.data;
}

export async function postTianji<T>(path: string, body: Record<string, unknown>, environment?: string): Promise<TianjiEnvelope<T>> {
  const requestId = typeof body.request_id === "string" ? body.request_id : undefined;
  const response = await api.post<TianjiEnvelope<T>>(`${TIANJI_ADMIN_PREFIX}/${path}`, body, { headers: headers(environment, requestId) });
  return response.data;
}

export async function patchTianji<T>(path: string, body: Record<string, unknown>, environment?: string): Promise<TianjiEnvelope<T>> {
  const requestId = typeof body.request_id === "string" ? body.request_id : undefined;
  const response = await api.patch<TianjiEnvelope<T>>(`${TIANJI_ADMIN_PREFIX}/${path}`, body, { headers: headers(environment, requestId) });
  return response.data;
}

export async function exportTianji(path: string, filename: string): Promise<void> {
  const response = await api.get(`${TIANJI_ADMIN_PREFIX}/${path}`, { headers: headers(), responseType: "blob" });
  const href = URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = href;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(href);
}
